import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledTypography = styled(Typography)(({ theme, color }) => ({
  fontWeight: 600,
  color: `${color || theme.palette.primary.main}`,
}));
